const UpdateRoleForm = () => {
  return <div>UpdateRoleForm</div>;
};

export default UpdateRoleForm;
